import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';

const initialOfferSlug =
  typeof window !== 'undefined'
    ? (new URLSearchParams(window.location.search).get('offer') ?? undefined)
    : undefined;

const offerSlug = ref<string | undefined>(initialOfferSlug);

const getQueryOfferSlug = (route: Pick<RouteLocationNormalized, 'query'>) =>
  typeof route.query.offer === 'string' ? route.query.offer : undefined;

const getRouteRedirectTarget = (to: RouteLocationNormalized): RouteLocationRaw => {
  if (to.name) {
    return {
      name: to.name,
      params: to.params,
      hash: to.hash,
    };
  }

  return {
    path: to.path,
    hash: to.hash,
  };
};

export const useOfferContext = () => {
  const setOfferSlug = (slug?: string) => {
    if (offerSlug.value === slug) return false;
    offerSlug.value = slug;
    return true;
  };

  const clearOfferSlug = () => setOfferSlug(undefined);

  const syncFromRoute = (route: Pick<RouteLocationNormalized, 'query'>) => {
    const routeOffer = getQueryOfferSlug(route);
    if (!routeOffer) return false;
    return setOfferSlug(routeOffer);
  };

  const ensureOfferInQuery = (to: RouteLocationNormalized) => {
    if (!offerSlug.value) return;
    if (getQueryOfferSlug(to) === offerSlug.value) return;

    return {
      ...getRouteRedirectTarget(to),
      query: { ...to.query, offer: offerSlug.value },
    } satisfies RouteLocationRaw;
  };

  return {
    offerSlug,
    setOfferSlug,
    clearOfferSlug,
    syncFromRoute,
    ensureOfferInQuery,
  };
};
